export const VARIABLE_TYPES = ["string", "number", "boolean", "date", "datetime"] as const;

export type VariableType = (typeof VARIABLE_TYPES)[number];
